import { useEffect } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { functionWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { useFlagService } from '@atlassian/jira-flags/src';
import {
	useErrorCode,
	useError,
	useIssueAdjustmentsActions,
} from '@atlassian/jira-issue-adjustments/src/controllers/issue-adjustments';
import { useErrorFlagConfig, useErrorFlagConfigOld } from './hooks';

// remove ErrorFlagsOld with forge-ui-modifications-validation-errors-returned-to-app_hdzmw FF removal
export const ErrorFlagsOld = () => {
	const errorCode = useErrorCode();
	const { showFlag } = useFlagService();
	const errorFlag = useErrorFlagConfigOld({ errorCode });
	const { resetError } = useIssueAdjustmentsActions();

	useEffect(() => {
		if (errorFlag) {
			showFlag(errorFlag);
			resetError();
		}
	}, [errorFlag, resetError, showFlag]);
	return null;
};

export const ErrorFlagsNew = () => {
	const errorProperties = useError();
	const { showFlag } = useFlagService();
	const errorFlag = useErrorFlagConfig(errorProperties);
	const { resetError } = useIssueAdjustmentsActions();

	useEffect(() => {
		if (errorFlag) {
			showFlag(errorFlag);
			resetError();
		}
	}, [errorFlag, resetError, showFlag]);
	return null;
};

export const ErrorFlags = functionWithCondition(
	() => ff('forge-ui-modifications-validation-errors-returned-to-app_hdzmw'),
	ErrorFlagsNew,
	ErrorFlagsOld,
);
